export const INVITE_STATUS = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  DECLINED: "declined",
  CANCELLED: "cancelled",
  NOT_INVITED: "not_invited",
}

export const INVITE_STATUS_LABELS = {
  [INVITE_STATUS.PENDING]: "Invited",
  [INVITE_STATUS.ACCEPTED]: "Accepted",
  [INVITE_STATUS.DECLINED]: "Declined",
  [INVITE_STATUS.CANCELLED]: "Cancelled",
  [INVITE_STATUS.NOT_INVITED]: "Not Invited",
}
